import { SetHeaderService } from "@/helper/userHelper";
import service from "../baseHttpService";

class ExecutiveSummaryService {
  DoGetExecutiveSummaryTable(input: any) {
    const _input = {
      tableSearchCriteria: {
        pageNo: input ? input.pageNo : 1,
        pageSize: input ? input.pageSize : 10,
        searchText: input.searchText,
        tableStatusType: input ? input.tableStatusType : 0,
        sortingType: input ? input.sortingType : 0,
        orderType: input ? input.orderType : 0,
      },
    };
    return service.peakExportAPI
      .post("/api/Table/GetExecutiveSummaryTable", _input, SetHeaderService(true))
      .then((res) => {
        return res;
      });
  }
  DoGetExecutiveSummaryTransactionForCreate(input: any) {
    const _input = {
      fromDate: input.fromDate,
      toDate: input.toDate,
      executiveSummaryPeriodType: input.executiveSummaryPeriodType,
    };
    return service.peakExportAPI
      .post("/api/ExecutiveSummary/GetExecutiveSummaryTransactionForCreate", _input, SetHeaderService(true))
      .then((res) => {
        return res;
      });
  }
  DoCreateExecutiveSummary(_input: any) {
    const input = {
      executiveSummary: _input,
    };
    return service.peakRealTimeAPI
      .post("/api/ExecutiveSummary/CreateExecutiveSummary", input, SetHeaderService(true))
      .then((res) => {
        return res;
      });
  }
  DoUpdateExecutiveSummary(_input: any) {
    const input = {
      executiveSummaryId: _input.executiveSummaryId,
      executiveSummary: _input.executiveSummary,
      status: _input.status,
    };
    return service.peakRealTimeAPI
      .post("/api/ExecutiveSummary/UpdateExecutiveSummary", input, SetHeaderService(true))
      .then((res) => {
        return res;
      });
  }
  DoGetSuggestionExecusiveSummaryNumber(date: any) {
    const input = {
      date: date,
    };
    return service.peakRealTimeAPI
      .post("/api/ExecutiveSummary/GetSuggestionExecusiveSummaryNumber", input, SetHeaderService(true))
      .then((res) => {
        return res;
      });
  }
  DoGetExecutiveSummaryDetail(executiveSummaryId: any) {
    const input = {
      executiveSummaryId: executiveSummaryId,
    };
    return service.peakRealTimeAPI
      .post("/api/ExecutiveSummary/GetExecutiveSummaryDetail", input, SetHeaderService(true))
      .then((res) => {
        return res;
      });
  }
  DoVoidExecutiveSummary(executiveSummaryId: any) {
    const input = {
      executiveSummaryId: executiveSummaryId,
    };
    return service.peakRealTimeAPI
      .post("/api/ExecutiveSummary/VoidExecutiveSummary", input, SetHeaderService(true))
      .then((res) => {
        return res;
      });
  }
  DoUpdateExecutiveSummaryStatus(_input: any) {
    const input = {
      executiveSummaryId: _input.executiveSummaryId,
      status: _input.status,
    };
    return service.peakRealTimeAPI
      .post("/api/ExecutiveSummary/UpdateExecutiveSummaryStatus", input, SetHeaderService(true))
      .then((res) => {
        return res;
      });
  }
  DoExportExecutiveSummary(input: any) {
    return service.peakExportAPI
      .post("/api/EmailReport/ExportExecutiveSummary", input, SetHeaderService(true))
      .then((res) => {
        return res;
      });
  }
}

export default new ExecutiveSummaryService();
